module.exports = __webpack_public_path__ + "static/media/btn_delete_patient.2c205ca0.svg";